import { render } from "./BarqAnswers.vue?vue&type=template&id=209688dc&scoped=true"
import script from "./BarqAnswers.vue?vue&type=script&lang=js"
export * from "./BarqAnswers.vue?vue&type=script&lang=js"

import "./BarqAnswers.vue?vue&type=style&index=0&id=209688dc&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-209688dc"]])

export default __exports__